import registerElementPlus from "./elementPlus/elementPlus";

const registerPlugins = app => {
  registerElementPlus(app);
};

export default registerPlugins;
